import React from "react";
import videojs from "video.js";
import { setLocation, signUpModal } from "../redux/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Video from "../components/Video";
import OwlCarousel from "react-owl-carousel";
import { useState } from "react";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import { config } from "../config";
import { useEffect } from "react";

export const LandingPage = () => {
  const dispatch = useDispatch();
  const currentPath = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const location = useSelector((state) => state.modal.location);
  console.log("location ::", location);
  const playerRef = React.useRef(null);

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on("waiting", () => {
      videojs.log("player is waiting");
    });
    // player.on("mouseenter", () => {
    //   videojs.log("player is waiting enter", player);
    //   player.bigPlayButton.handleClick();
    // });
    // player.on("mouseleave", function () {
    //   videojs.log("player is waiting leave", player);
    //   player.pause();
    //   player.bigPlayButton.show();
    // });

    player.on("dispose", () => {
      videojs.log("player will dispose");
    });
  };

  const [searchedLocation, setSearchedLocation] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState(searchParams.get("query") || "");

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearchInputKeyDown = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      setSearchParams({ query: e.target.value });
      navigate("/posts?query=" + e.target.value);
    }
  };

  //carosule slider index handled::start
  const [activeIndex, setActiveIndex] = useState(0);
  //carosule slider index handled:: end

  //location change event ::start
  useEffect(() => {
    if (searchedLocation !== "") {
      let { address_components } = searchedLocation;

      if (address_components && address_components.length) {
        let state = "",
          stateCode = "",
          city = "",
          country = "";
        address_components.map((address, index) => {
          if (address_components[index].types.includes("locality")) {
            city = searchedLocation && searchedLocation.address_components[index].long_name;
          } else if (address_components[index].types.includes("sublocality")) {
            city = searchedLocation && searchedLocation.address_components[index].long_name;
          } else if (address_components[index].types.includes("administrative_area_level_1")) {
            state = searchedLocation && searchedLocation.address_components[index].long_name;
            stateCode = searchedLocation && searchedLocation.address_components[index].short_name;
          } else if (address_components[index].types.includes("country")) {
            country = searchedLocation && searchedLocation.address_components[index].long_name;
          }
        });
        if (state !== "" && country !== "") {
          // console.log("searchedLocation :: ", searchedLocation);
          dispatch(setLocation(city !== "" ? `${city}, ${stateCode}, ${country}` : `${stateCode}, ${country}`));
        } else if (country !== "") {
          // console.log("searchedLocation :: ", searchedLocation);
          dispatch(setLocation(`${country}`));
        } else {
          // console.log("not searchedLocation :: ", searchedLocation, "=====", state + ", " + country);
          dispatch(setLocation("United States"));
        }
      }
    }
  }, [searchedLocation]);

  useEffect(() => {
    if (localStorage.getItem("location")) {
      setSearchedLocation(localStorage.getItem("location"));
    }
  }, []);
  //location change event ::end

  return (
    <>
      {/* <!-- slider and serch text --> */}
      <div className="slider_carouser">
        <div className="container">
          <div className="inside_slider">
            <h1>
              Discover local places
              <br /> and products
            </h1>
            <p>
              We're a social platform connecting our users with a curated
              <br /> selection of hotels, restaurants and travel experiences.
            </p>
            <div className="serach_bar">
              <ul className="navbar-nav m-auto ">
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fas fa-map-marker-alt"></i> {location === "anywhere" ? "Explore" : location}
                  </a>
                  <ul className="dropdown-menu location_drop">
                    <li>
                      <form>
                        <ReactGoogleAutocomplete
                          options={{
                            types: ["(regions)"],
                          }}
                          apiKey={config.google_api_key}
                          onPlaceSelected={(place) => {
                            setSearchedLocation(place);
                            let el = document.querySelector("#navbarSupportedContent");
                            if (el !== null) el.click();
                          }}
                          className="form-control"
                        />
                      </form>
                    </li>
                  </ul>
                </li>
              </ul>
              <form className="search_box" role="search">
                <div className="d-flex align-items-center">
                  <img src={require("../assets/images/line_shape.png")} className="img_shape" />
                  <input className="form-control me-2" type="search" placeholder="What do you want to explore? Ex: cozy restaurants, modern wine bar" aria-label="Search" value={searchValue} onChange={(e) => handleSearchInputChange(e)} onKeyDown={(e) => handleSearchInputKeyDown(e)} />
                  <button className="" onClick={() => navigate("/posts?query=" + searchValue)}>
                    Explore Now
                  </button>
                </div>
              </form>
            </div>
            {/* <div className="serach_tag">
              <Link to={"/posts?query=hotel"} className="tag_serch">
                <img src={require("../assets/images/Serach_dark.png")} alt="" title="" />
                Hotel
              </Link>
              <Link to={"/posts?query=restaurant"} className="tag_serch">
                <img src={require("../assets/images/Serach_dark.png")} alt="" title="" />
                Restaurant
              </Link>
              <Link to={"/posts?query=experiences"} className="tag_serch">
                <img src={require("../assets/images/Serach_dark.png")} alt="" title="" />
                Experiences
              </Link>
            </div> */}
          </div>
        </div>
      </div>

      {/* <!-- start feature place and product --> */}
      <div className="feature_place_product">
        <div className="container">
          <h2>we feature places and products like...</h2>
          <div className="place_product_img">
            <a href="javascript:void(0)" className="feature_img">
              <img src={require("../assets/images/feature_img1.png")} alt="" title="" />
            </a>
            <a href="javascript:void(0)" className="feature_img">
              <img src={require("../assets/images/feature_img2.png")} alt="" title="" />
            </a>
            <a href="javascript:void(0)" className="feature_img">
              <img src={require("../assets/images/feature_img3.png")} alt="" title="" />
            </a>
            <a href="javascript:void(0)" className="feature_img">
              <img src={require("../assets/images/feature_img4.png")} alt="" title="" />
            </a>
          </div>
        </div>
      </div>

      {/* <!-- start what is thruhike --> */}
      <div className="container">
        <div className="about_thruhike">
          <div className="row align-items-center">
            <div className="col-md-6 col-lg-6 col-sm-12 col-12">
              <h3>What is Thruhike?</h3>
              <p className="green_color">Make an account. It's free.</p>
              <p>Our goal is to connect people with local places and products in their community and beyond. The content you see is curated by our team with each individual user in mind based on factors such as quality, community impact, sustainability, and more. All you need to do is make an account to start discovering, experiencing and sharing what you love.</p>
              <button type="button" className="btn btn-primary save" onClick={() => dispatch(signUpModal(true))}>
                Make an account
              </button>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-12 col-12">
              <img src={require("../assets/images/about_thruhike.png")} alt="" title="" />
            </div>
          </div>
        </div>
      </div>

      {/* <!-- start explore feture --> */}
      <div className="explore_fetures">
        <div className="container">
          <div className="about_thruhike">
            <div className="row align-items-center justify-content-between your_favriout">
              <div className="col-lg-5 col-md-6 col-sm-6 trail_width_responsive">
                <div className="trail_post">
                  <div className="trail_post_user">
                    <div className="user_img">
                      <a href="javascript:void(0)">
                        <img src={require("../assets/images/user2.png")} alt="" title="" />
                      </a>
                    </div>
                    <h4>
                      <a href="javascript:void(0)">Seapoint Beach</a>
                    </h4>
                    <p>
                      Outing
                      <a href="javascript:void(0)">
                        <span className="float-end">
                          <i className="fas fa-map-marker-alt"></i>&nbsp; Kittery, ME, United States
                        </span>
                      </a>
                    </p>
                  </div>
                  <a href="javascript:void(0)">
                    <div className="trail_post_img video_icon">
                      {/* <img src={require("../assets/images/play.png")} alt="" title="" className="video_play" />
                      <img src={require("../assets/images/trailpost2.png")} alt="" title="" /> */}
                      <Video
                        key={"media_post_video"}
                        options={{
                          preload: "auto",
                          autoplay: false,
                          controls: true,
                          responsive: true,
                          fluid: true,
                          sources: [
                            {
                              src: "https://ik.imagekit.io/h56kvej7o/media_image/media_image_0_1677685508.mp4/ik-master.m3u8?tr=sr-480_720_1080",
                              type: "application/x-mpegURL",
                            },
                          ],
                          poster: "https://ik.imagekit.io/h56kvej7o/media_image/media_image_0_1677685508.mp4/ik-thumbnail.jpg?tr=w-900,h-600,c-force",
                        }}
                        onReady={handlePlayerReady}
                      />
                    </div>
                  </a>
                  <div className="post_detail">
                    <a data-bs-toggle="modal" data-bs-target="#tagadd">
                      <span className="badge">Add your #</span>
                    </a>
                    <div className="trail_tag_like">
                      <a data-bs-toggle="modal" data-bs-target="#sharepost" className="social_icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.81818 2.00002L6.90909 4.90911H9.09091V11.4546H10.5455V4.90911H12.7273M14.1818 18H5.45455C4.64727 18 4 17.3455 4 16.5455V7.8182C4 7.43243 4.15325 7.06246 4.42603 6.78968C4.69881 6.5169 5.06878 6.36366 5.45455 6.36366H7.63636V7.8182H5.45455V16.5455H14.1818V7.8182H12V6.36366H14.1818C14.5676 6.36366 14.9376 6.5169 15.2103 6.78968C15.4831 7.06246 15.6364 7.43243 15.6364 7.8182V16.5455C15.6364 16.9312 15.4831 17.3012 15.2103 17.574C14.9376 17.8468 14.5676 18 14.1818 18Z"
                            fill="#66737F"
                          />
                        </svg>
                      </a>
                      <a data-bs-toggle="modal" data-bs-target="#traipopup" className="social_icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.0833 3.33333C11.1666 3.41667 11.1666 3.41667 11.1666 4C11.1666 4.25 11.1666 4.5 11.1666 4.58333C11.1666 4.58333 11.4999 4.58333 13.4166 4.66667H15.5833L16.0833 5.25C16.4999 5.58333 16.6666 5.83333 16.6666 5.83333C16.6666 5.83333 16.4999 6.08333 16.1666 6.5L15.6666 7.08333H13.4999C11.5833 7.08333 11.2499 7.08333 11.2499 7.16667C11.2499 7.16667 11.2499 7.58333 11.2499 8.16667C11.2499 9 11.2499 9.08333 11.2499 9.16667C11.2499 9.16667 11.3333 9.25 11.9166 9.25H12.5833L12.6666 9.16667C12.7499 9.25 12.7499 9.25 12.7499 10.3333C12.7499 11.0833 12.7499 11.5 12.7499 11.5C12.5833 11.6667 12.5833 11.6667 11.8333 11.6667C11.3333 11.6667 11.1666 11.6667 11.1666 11.6667C11.1666 11.6667 11.1666 12.25 11.1666 14.0833V16.5L11.0833 16.5833V16.6667H9.99995H8.99995L8.91661 16.5833L8.83328 16.5V14.1667C8.83328 12.3333 8.83328 11.75 8.83328 11.75C8.83328 11.75 8.24995 11.75 6.58328 11.75H4.41661L3.91661 11.1667C3.58328 10.75 3.33328 10.5 3.33328 10.4167V10.3333C3.33328 10.3333 3.58328 10 3.83328 9.66667L4.33328 9.08333H6.49995C8.49995 9.08333 8.66661 9.08333 8.74995 9.08333C8.83328 9.08333 8.83328 9 8.83328 8.08333C8.83328 7.25 8.83328 7.16667 8.83328 7.08333C8.83328 7.08333 8.66661 7.08333 8.16661 7.08333C7.58328 7.08333 7.49995 7.08333 7.41661 7H7.33328V5.83333V4.66667L7.41661 4.58333L7.49995 4.5H8.16661C8.74995 4.5 8.83328 4.5 8.83328 4.5C8.83328 4.5 8.83328 4.41667 8.83328 3.91667C8.83328 3.41667 8.83328 3.41667 8.91661 3.33333H8.99995H9.99995H11.0833ZM11.7499 1.66667H11.0833H9.99995H8.99995H8.24995L7.74995 2.16667V2.25C7.49995 2.41667 7.33328 2.66667 7.33328 2.91667H6.74995L6.24995 3.33333V3.41667L6.16661 3.5L5.66661 4V4.66667V5.83333V7V7.5H4.33328H3.58328L3.08328 8L2.58328 8.58333C1.99995 9.25 1.83328 9.41667 1.74995 9.66667C1.58328 10.1667 1.58328 10.6667 1.83328 11.1667C1.91661 11.3333 1.91661 11.4167 2.58328 12.1667L3.08328 12.75L3.66661 13.3333H4.41661H6.58328C6.74995 13.3333 6.91661 13.3333 7.16661 13.3333C7.16661 13.6667 7.16661 13.9167 7.16661 14.1667V16.5833V17.25L7.66661 17.75L7.74995 17.8333L7.83328 17.9167L8.24995 18.3333H8.91661H9.99995H11.0833H11.7499L12.2499 17.8333L12.3333 17.75L12.4166 17.6667L12.9166 17.1667V16.5V14.1667C12.9166 13.9167 12.9166 13.6667 12.9166 13.3333C13.4166 13.25 13.9166 13 14.2499 12.3333C14.4166 11.9167 14.4166 11.6667 14.4166 10.5C14.4166 9.66667 14.4166 9.16667 14.3333 8.91667H15.7499H16.4999L16.9999 8.33333L17.4999 7.75C17.9999 6.91667 18.3333 6.5 18.3333 5.83333C18.3333 5.16667 17.9999 4.75 17.4166 4.08333L16.9166 3.5L16.4166 2.91667H15.6666H13.4999C13.2499 2.91667 12.9999 2.91667 12.7499 2.91667C12.6666 2.66667 12.4999 2.41667 12.3333 2.25L12.2499 2.16667L11.7499 1.66667Z"
                            fill="#66737F"
                          />
                        </svg>
                      </a>
                      <a className="social_icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.0834 15.4583L10.0001 15.5417L9.90841 15.4583C5.95008 11.8667 3.33341 9.49167 3.33341 7.08333C3.33341 5.41667 4.58341 4.16667 6.25008 4.16667C7.53341 4.16667 8.78341 5 9.22508 6.13333H10.7751C11.2167 5 12.4667 4.16667 13.7501 4.16667C15.4167 4.16667 16.6667 5.41667 16.6667 7.08333C16.6667 9.49167 14.0501 11.8667 10.0834 15.4583ZM13.7501 2.5C12.3001 2.5 10.9084 3.175 10.0001 4.23333C9.09175 3.175 7.70008 2.5 6.25008 2.5C3.68341 2.5 1.66675 4.50833 1.66675 7.08333C1.66675 10.225 4.50008 12.8 8.79175 16.6917L10.0001 17.7917L11.2084 16.6917C15.5001 12.8 18.3334 10.225 18.3334 7.08333C18.3334 4.50833 16.3167 2.5 13.7501 2.5Z"
                            fill="#66737F"
                          />
                        </svg>
                        {/* <span className="favriout_hover">
                          Added in your Favorite Trail <i className="fas fa-heart"></i>
                        </span> */}
                      </a>
                    </div>
                    <p className="post_description">Seapoint Beach is a hidden gem. At the end of a residential neighborhood, lies a community beach for walking, relaxing and the off-hours dog walk.</p>
                    <div className="tag_list">
                      <a href="#">
                        <span>#beachy</span>
                      </a>
                      <a href="#">
                        <span>#hidden</span>
                      </a>
                      <a href="#">
                        <span>#relaxed</span>
                      </a>
                      <a href="#">
                        <span>#free</span>
                      </a>
                      <a href="#">
                        <span>#rustic</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 col-lg-6 col-sm-12 col-12 position-relative">
                <img src={require("../assets/images/frame_img.png")} alt="" title="" />
                <a href="javascript:void(0)">
                  <div className="trail_post_img video_icon">
                    <Video
                      key={"media_post_video"}
                      options={{
                        preload: "auto",
                        autoplay: false,
                        controls: true,
                        responsive: true,
                        fluid: true,
                        sources: [
                          {
                            src: "https://ik.imagekit.io/h56kvej7o/media_image/media_image_0_1677685508.mp4/ik-master.m3u8?tr=sr-480_720_1080",
                            type: "application/x-mpegURL",
                          },
                        ],
                        poster: "https://ik.imagekit.io/h56kvej7o/media_image/media_image_0_1677685508.mp4/ik-thumbnail.jpg?tr=w-900,h-600,c-force",
                      }}
                      onReady={handlePlayerReady}
                    />
                  </div>
                </a>
              </div> */}
              <div className="col-md-6 col-lg-6 col-sm-12 col-12">
                <h3>Explore our features</h3>
                <p className="green_color">We are constantly updating our platform to support you and our local communities.</p>
                <div className="tab-categories-wrapper">
                  <a href="javascript:void(0)" id="tab1" className={activeIndex === 0 ? "category-tab activated" : "category-tab"} type="button" onClick={() => setActiveIndex(0)}>
                    Video Content
                  </a>
                  <a href="javascript:void(0)" id="tab2" className={activeIndex === 1 ? "category-tab activated" : "category-tab"} type="button" onClick={() => setActiveIndex(1)}>
                    Share
                  </a>
                  <a href="javascript:void(0)" id="tab3" className={activeIndex === 2 ? "category-tab activated" : "category-tab"} type="button" onClick={() => setActiveIndex(2)}>
                    Trail List
                  </a>
                  <a href="javascript:void(0)" id="tab4" className={activeIndex === 3 ? "category-tab activated" : "category-tab"} type="button" onClick={() => setActiveIndex(3)}>
                    Updates
                  </a>
                </div>
                <OwlCarousel
                  className="owl-carousel feature_slider"
                  loop={false}
                  mouseDrag={false}
                  nav={true}
                  dots={false}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    480: {
                      items: 1,
                    },
                    768: {
                      items: 1,
                    },
                    1152: {
                      items: 1,
                    },
                  }}
                  navText={["<div className='fas fa-chevron-left'></div>", "<div className='fas fa-chevron-right'></div>"]}
                  id="our_feature_slider"
                  startPosition={activeIndex}
                  onChanged={(e) => setActiveIndex(e.item.index)}
                >
                  <div className="item">
                    <div className="col-md-12">
                      <p>Immerse yourself in each place and product with authentic video content.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="col-md-12">
                      <p>Upvote, share, favorite and add places and products to trail lists. This is how we build a better experience for you and the rest of our Thruhike community so you don't have to sort through endless bot reviews and ads.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="col-md-12">
                      <p>What's a Trail List? Imagine a playlist of places and products created by you, your trusted friends or our curators. It could be as simple as a classic itinerary or it could lay out the perfect experience from the places you'll go to the music you'll listen to and the outfits you'll wear. The possibilities are endless.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="col-md-12">
                      <p>
                        See updates from your favorite local places and products. Imagine the local town bulletin board digitized. <br />
                        PS Select vendors even go the extra mile of adding a personal touch to your experience based on your Thruhike profile.
                      </p>
                    </div>
                  </div>
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- start curated content --> */}
      <div className="container">
        <div className="about_thruhike">
          <div className="row align-items-center">
            <div className="col-md-6 col-lg-6 col-sm-12 col-12">
              <h3>There’s more to Thruhike than curated content.</h3>
              <p className="green_color">Want to experience our Thruhike Concierge?</p>
              <p>Try out one of our paid membership to get access to</p>
              <a href="https://www.canva.com/design/DAFfRry5cNY/uFg_TthwHKJIEXzQbqWFqA/view?utm_content=DAFfRry5cNY&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink" target="_blank" type="button" className="btn btn-primary save">
                Learn more
              </a>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-12 col-12">
              <div className="curated_content">
                <img src={require("../assets/images/businessman.png")} alt="" title="" />
                <p>On-Demand Travel Agent</p>
              </div>
              <div className="curated_content">
                <img src={require("../assets/images/like.png")} alt="" title="" />
                <p>Exclusive content and perks</p>
              </div>
              <div className="curated_content">
                <img src={require("../assets/images/premium.png")} alt="" title="" />
                <p>Personalized experiences and VIP memberships at select Thruhike vendors</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- start app coming soon --> */}
      <div className="explore_fetures">
        <div className="container">
          <div className="about_thruhike">
            <div className="coming_soon_app">
              <div className="row align-items-center">
                <div className="col-md-6 col-lg-6 col-sm-12 col-12">
                  <h3 className="mb-0">Want adventure at your fingertips? Our app is coming soon</h3>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-12 col-12">
                  <div className="app_icon d-flex align-items-center justify-content-between">
                    <a href="javascript:void(0)">
                      <img src={require("../assets/images/apple_store.png")} alt="" title="" />
                    </a>
                    <a href="javascript:void(0)">
                      <img src={require("../assets/images/play_store.png")} alt="" title="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
